import { Dog, CalendarDays, AlertCircle, Mail, Info, Briefcase } from "lucide-react";

const STYLE = {
  dog: { cls: "bg-amber-100 text-amber-800 border-amber-200", Icon: Dog },
  service: { cls: "bg-cyan-50 text-cyan-800 border-cyan-200", Icon: Briefcase },
  date: { cls: "bg-emerald-50 text-emerald-800 border-emerald-200", Icon: CalendarDays },
  concern: { cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: AlertCircle },
  email: { cls: "bg-violet-50 text-violet-700 border-violet-200", Icon: Mail },
  info: { cls: "bg-slate-50 text-slate-600 border-slate-200", Icon: Info },
};

// "What the AI used" chips above a draft (dog names, service, dates, concerns…).
export const ProfileTags = ({ tags }) => {
  if (!tags?.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="draft-profile-tags">
      {tags.map((t, i) => {
        const st = STYLE[t.kind] || STYLE.info;
        const past = t.kind === "date" && t.past;
        return (
          <span key={i} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${past ? "bg-slate-100 text-slate-500 border-slate-200 line-through decoration-slate-400" : st.cls}`}
            title={past ? "Requested date has passed" : ""} data-testid={`profile-tag-${t.kind}-${i}`}>
            <st.Icon className="w-3 h-3" />{t.label}
          </span>
        );
      })}
    </div>
  );
};
